import React from 'react';

const Home = () => (
  <div className="home-section-container">
    <h2 className="heading-text">
      Welcome to our page!
    </h2>
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elit.
      Animi cumque sit quaerat cum,ratione soluta! Eveniet, magnam
      eum ea excepturi et temporibus laborum at officia!
    </p>
    <p>
      Lorem ipsum, dolor sit amet consectetur adipisicing elite.
      Animi cumque sit quaerat cum, ratione soluta! Eveniet, magnam
      eum ea excepturi et temporibus laborum at officia!
    </p>
  </div>
);

export default Home;
